import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["tinymce"]

  async saveBeforeAction(e) {
    await this.tinymceOutlet.waitUntilLoaded()

    // If content needs to be saved, prevent the action, save the content, then re-dispatch the action
    if (!this.tinymceOutlet.upToDate()) {
      e.preventDefault()

      await this.tinymceOutlet.save()

      const newEvent = new e.constructor(e.type, e)
      this.element.dispatchEvent(newEvent)
    }
  }
}
